import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ProgramRole } from '@app/shared/enums';
import {
  ComparisonSelectorsApiModel,
  TraineePerformanceReportFiltersApiModel,
  TraineePerformanceReportRequestApiModel,
  TraineePerformanceReportApiModel,
  TrainerPerformanceReportFiltersApiModel,
  TrainerPerformanceReportRequestApiModel,
  TrainerPerformanceReportApiModel
} from '@app/api/api-models';
import { IncidentsReportFiltersApiModel } from '@app/api/api-models/pe-reports/incidents-report/IncidentsReportFiltersApiModel';
import { IncidentsReportApiModel } from '@app/api/api-models/pe-reports/incidents-report/IncidentsReportApiModel';
import { IncidentsReportRequestApiModel } from '@app/api/api-models/pe-reports/incidents-report/IncidentsReportRequestApiModel';
import { PrintApiModel } from '@app/api/api-models/reports/PrintApiModel';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class PeReportsService {
  public apiUrl = 'pe-reports';

  constructor(private readonly http: HttpClientService) {}

  public getComparisonSelectors(role?: ProgramRole): Observable<ComparisonSelectorsApiModel> {
    return this.http.get<ComparisonSelectorsApiModel>(`${this.apiUrl}/comparison-selectors?role=${role}`);
  }

  public getIncidentsFilterData(): Observable<IncidentsReportFiltersApiModel> {
    return this.http.get<IncidentsReportFiltersApiModel>(`${this.apiUrl}/incidents/filters`);
  }

  public getIncidentsReport(model: IncidentsReportRequestApiModel): Observable<IncidentsReportApiModel> {
    return this.http.post<IncidentsReportApiModel>(`${this.apiUrl}/incidents/report`, model);
  }

  public getIncidentsPrint(model: PrintApiModel<IncidentsReportRequestApiModel>): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/incidents/pdf`, model, { responseType: 'blob' });
  }

  public getIncidentsXlsx(model: IncidentsReportRequestApiModel): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/incidents/xlsx`, model, { responseType: 'blob' });
  }

  public getTraineePerformanceFilterData(): Observable<TraineePerformanceReportFiltersApiModel> {
    return this.http.get<TraineePerformanceReportFiltersApiModel>(`${this.apiUrl}/employee-performance/filters`);
  }

  public getTraineePerformanceReport(
    filters: TraineePerformanceReportRequestApiModel
  ): Observable<TraineePerformanceReportApiModel> {
    return this.http.post<TraineePerformanceReportApiModel>(`${this.apiUrl}/employee-performance/report`, filters);
  }

  public getTraineePerformancePrint(model: PrintApiModel<TraineePerformanceReportRequestApiModel>): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/employee-performance/pdf`, model, { responseType: 'blob' });
  }

  public getTraineePerformanceXlsx(filters: TraineePerformanceReportRequestApiModel): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/employee-performance/xlsx`, filters, { responseType: 'blob' });
  }

  public getSupervisorPerformanceFilterData(): Observable<TrainerPerformanceReportFiltersApiModel> {
    return this.http.get<TrainerPerformanceReportFiltersApiModel>(`${this.apiUrl}/supervisor-performance/filters`);
  }

  public getSupervisorPerformanceReport(
    filters: TrainerPerformanceReportRequestApiModel
  ): Observable<TrainerPerformanceReportApiModel> {
    return this.http.post<TrainerPerformanceReportApiModel>(`${this.apiUrl}/supervisor-performance/report`, filters);
  }

  public getSupervisorPerformancePrint(
    model: PrintApiModel<TrainerPerformanceReportRequestApiModel>
  ): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/supervisor-performance/pdf`, model, { responseType: 'blob' });
  }

  public getSupervisorPerformanceXlsx(filters: TrainerPerformanceReportRequestApiModel): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/supervisor-performance/xlsx`, filters, { responseType: 'blob' });
  }
}
